module.exports = __webpack_public_path__ + "assets/img/b.3d157cc1.jpg";